import React from 'react';
import { FadeIn } from './Shared';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  location: string;
}
const TestimonialCard = ({
  quote,
  author,
  location
}: TestimonialProps) => <div className="bg-navy-800/50 p-8 rounded-2xl border border-navy-700 relative" data-id="element-301">
    <Quote className="absolute top-6 right-6 w-8 h-8 text-navy-600 opacity-50" data-id="element-302" />
    <div className="text-gold-400 mb-4 text-sm" data-id="element-303">⭐⭐⭐⭐⭐</div>
    <p className="text-lg text-gray-300 italic mb-6 relative z-10" data-id="element-304">"{quote}"</p>
    <div data-id="element-305">
      <div className="font-bold text-white" data-id="element-306">{author}</div>
      <div className="text-sm text-gray-500" data-id="element-307">{location}</div>
    </div>
  </div>;
export const Testimonials = () => {
  return <section className="py-8 md:py-12 px-4" data-id="element-308">
      <div className="max-w-4xl mx-auto" data-id="element-309">
        <FadeIn data-id="element-310">
          <div className="grid md:grid-cols-2 gap-6" data-id="element-311">
            <TestimonialCard quote="La tercera noche ya dormió 5 horas seguidas. Ojalá lo hubiera tenido desde el primer mes." author="Valeria R." location="Buenos Aires" data-id="element-312" />
            <TestimonialCard quote="No era el bebé. Éramos nosotros que lo acostábamos fuera de ventana. El Tomo 3 lo cambió todo." author="Melisa S." location="Córdoba" data-id="element-313" />
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const MoreTestimonials = () => {
  return <section className="py-8 md:py-12 px-4 bg-navy-800/30" data-id="element-314">
      <div className="max-w-4xl mx-auto" data-id="element-315">
        <FadeIn data-id="element-316">
          <h2 className="text-xl md:text-3xl font-serif font-bold text-center text-white mb-8" data-id="element-317">
            <span className="text-red-500 mr-2" data-id="element-318">❤️</span> MÁS FAMILIAS QUE YA
            DUERMEN MEJOR
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-319">
            <TestimonialCard quote="Mi pareja y yo teníamos estrategias distintas y eso arruinaba todo. El sistema nos alineó en una semana." author="Julián P." location="Rosario" data-id="element-320" />
            <TestimonialCard quote="El Manual de Crisis a las 3 AM es lo que toda mamá necesita tener en el celular." author="Carolina R." location="Mendoza" data-id="element-321" />
          </div>
        </FadeIn>
      </div>
    </section>;
};